/**
 * channelListContentContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

/**
 * Styled channel list content container.
 */
const ChannelListContentContainer = styled.div`
  margin-left: ${32 * Screen.widthRatio}px;
  transition: ${TRANSITION.CHANNEL_LIST_CONTENT};
`;

export default ChannelListContentContainer;
